import React from "react";
import HeaderDescription from "../../../components/commons/HeaderDescription";
import AIAreaCard from "./AIAreaCard";
import { AI_AREA_SECTIONS } from "./aiAreaSections";

const AIAreaHome = () => {
  return (
    <div className="ai-area-page">
      <HeaderDescription
        heading="AI Integration"
        description="Choose a section to set up how the AI works with your files and settings."
      />

      <div className="ai-area-section-list">
        <div className="ai-area-section-list-header">
          <h2 className="font-16 font-600 m-0">Available sections</h2>
          <p className="font-12 text-light-grey m-0">
            Open a card to continue. More sections will be added here as new
            features become available.
          </p>
        </div>

        <div className="ai-area-card-grid">
          {AI_AREA_SECTIONS.map((section) => (
            <AIAreaCard key={section.id} section={section} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AIAreaHome;
